var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * Debounce - returns a debounced promise and a cancel method to cancel the promise.
 *
 * @template T
 * @template A
 * @param {(...args: A[]) => T} fn
 * @param {number} [ms=0]
 * @return {*}  {{ (...args: A[]): Promise<T>; cancel(): void; }}
 */
export var debounce = function (fn, ms) {
    if (ms === void 0) { ms = 0; }
    var timer = null;
    var cancelled = false;
    var debounced = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        cancelled = false;
        clearTimeout(timer);
        return new Promise(function (resolve) {
            timer = window === null || window === void 0 ? void 0 : window.setTimeout(function () {
                if (!cancelled) {
                    resolve(fn.apply(void 0, __spread(args)));
                }
            }, ms);
        });
    };
    debounced.cancel = function () {
        cancelled = true;
    };
    return debounced;
};
//# sourceMappingURL=debounce.js.map